import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import TweenMax from 'TweenMax';

const CollapseContext = React.createContext({});

const StyledContent = styled.div`
  overflow: hidden;
`;

class CollapseContent extends React.Component {
  static propTypes = {
    opened: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    TweenMax.set(this.contentNode, { height: 0 });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.opened !== nextProps.opened) {
      if (nextProps.opened) {
        TweenMax.set(this.contentNode, { height: 'auto' });
        const height = this.contentNode.offsetHeight;
        TweenMax.fromTo(this.contentNode, 0.35, { height: 0 }, { height, ease: Power1.easeIn });
      } else {
        TweenMax.to(this.contentNode, 0.25, { height: 0, ease: Power1.easeIn });
      }
    }
  }

  render() {
    const { children } = this.props;

    return <StyledContent innerRef={node => (this.contentNode = node)}>{children}</StyledContent>;
  }
}

const CollapseTrigger = ({ children }) => {
  return (
    <CollapseContext.Consumer>{({ onClick }) => <span onClick={onClick}>{children}</span>}</CollapseContext.Consumer>
  );
};

class Collapse extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
  };

  state = {
    opened: false,
  };

  static Content = ({ children }) => (
    <CollapseContext.Consumer>
      {({ opened }) => <CollapseContent opened={opened}>{children}</CollapseContent>}
    </CollapseContext.Consumer>
  );

  static Trigger = CollapseTrigger;

  toggle() {
    const newOpened = !this.state.opened;
    this.state.opened ? this.setState({ opened: false }) : this.setState({ opened: true });
    this.setState({ opened: newOpened });
    this.props.onChange && this.props.onChange(newOpened);
  }

  render() {
    return (
      <CollapseContext.Provider value={{ opened: this.state.opened, onClick: e => this.toggle(e) }}>
        {this.props.children}
      </CollapseContext.Provider>
    );
  }
}

export default Collapse;



// WEBPACK FOOTER //
// ./src/components/Collapse.js